"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SvgIconReminder = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _react = _interopRequireDefault(require("react"));

var SvgIconReminder = function SvgIconReminder(props) {
  return /*#__PURE__*/_react.default.createElement("svg", (0, _extends2.default)({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/_react.default.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/_react.default.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.02174 1.04348C7.02174 1.08455 7.01937 1.12507 7.01475 1.1649C9.22865 1.7267 9.63043 4.10471 9.63043 5.47826C9.63043 6.66826 10.4059 7.52592 10.9462 8.12341C11.235 8.44278 11.4565 8.68783 11.4565 8.86957C11.4565 9.3913 11.4565 10.4348 5.97826 10.4348C0.5 10.4348 0.5 9.3913 0.5 8.86957C0.5 8.68783 0.721568 8.44278 1.01035 8.12341C1.5506 7.52592 2.32609 6.66826 2.32609 5.47826C2.32609 4.10471 2.72787 1.7267 4.94177 1.1649C4.93716 1.12507 4.93478 1.08455 4.93478 1.04348C4.93478 0.467181 5.40196 0 5.97826 0C6.55456 0 7.02174 0.467181 7.02174 1.04348ZM5.97825 10.9565C5.28209 10.9565 4.6744 10.9397 4.14393 10.9092C4.49755 11.559 5.1864 12 5.97825 12C6.77011 12 7.45895 11.559 7.81258 10.9092C7.28211 10.9397 6.67441 10.9565 5.97825 10.9565Z",
    fill: "currentColor"
  })), /*#__PURE__*/_react.default.createElement("defs", null, /*#__PURE__*/_react.default.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/_react.default.createElement("rect", {
    width: 12,
    height: 12,
    fill: "white"
  }))));
};

exports.SvgIconReminder = SvgIconReminder;